import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useProject } from '@/context/ProjectContext';
import { calculateMetrics } from '@/utils/calculations';
import { MetricsCard } from './MetricsCard';
import { VarianceTable } from './VarianceTable';
import { CostBreakdownChart } from './CostBreakdownChart';
import { RevenueVsCostChart } from './RevenueVsCostChart';

export function SummaryPanel() {
  const { state } = useProject();
  const { data } = state;
  const metrics = calculateMetrics(data);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricsCard
          title="Total Value"
          value={metrics.totalRevenue}
          trend="up"
          type="currency"
        />
        <MetricsCard
          title="Total Costs"
          value={metrics.totalCosts}
          trend="down"
          type="currency"
        />
        <MetricsCard
          title="Profit/Loss"
          value={metrics.profit}
          trend={metrics.profit >= 0 ? 'up' : 'down'}
          type="currency"
        />
        <MetricsCard
          title="Margin"
          value={metrics.margin}
          trend={metrics.margin >= 0 ? 'up' : 'down'}
          type="percentage"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Value vs Costs</CardTitle>
          </CardHeader>
          <CardContent>
            <RevenueVsCostChart data={data} />
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Cost Breakdown</CardTitle>
          </CardHeader>
          <CardContent>
            <CostBreakdownChart costs={data.costs} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}